import { localePrefixes } from './locale-prefixes';
import { DEFAULT_LOCALE } from './locales';

export const getLocalePrefix = (locale: string) =>
  locale === DEFAULT_LOCALE
    ? ''
    : (localePrefixes[locale as keyof typeof localePrefixes] ?? `/${locale}`);

export const getLocalizedPathnames = (paths: string[], locales: string[]) => {
  const pathnames = locales.flatMap((locale) => {
    const prefix = getLocalePrefix(locale);

    return paths.map((path) => `${prefix}${path === '/' ? '' : path}` || '/');
  });

  return [...new Set(pathnames)];
};
